import _extends from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import React from "react";
import { Box, Container, Flex } from "@catchoftheday/cg-components";
import { jsx as ___EmotionJSX } from "@emotion/react";
export var PageLayoutZone = function PageLayoutZone(props) {
  return ___EmotionJSX(Container, _extends({
    pl: 3
  }, props, {
    flexDirection: "column"
  }));
};
export var HeadingZone = function HeadingZone(props) {
  return ___EmotionJSX(Flex, _extends({
    alignItems: "center",
    justifyContent: "space-between",
    mt: 6,
    pr: 2
  }, props));
};
export var FacetsZone = function FacetsZone(props) {
  return ___EmotionJSX(Box, _extends({
    backgroundColor: "white",
    display: {
      _: "none",
      md: "block"
    }
  }, props), ___EmotionJSX(Box, {
    width: "330px"
  }, props.children));
};
export var ProductsZone = function ProductsZone(props) {
  return ___EmotionJSX(Box, _extends({
    flexGrow: 1,
    pl: 2
  }, props));
};
export var ResultsZone = function ResultsZone(props) {
  return ___EmotionJSX(Flex, props);
};